<template>
    <div>
      <div class="uk-section uk-section-small">
        <h3 class="uk-text-center">Search</h3>
        <div class="uk-grid" uk-grid>
          <div class="uk-width-1-1 uk-text-center">
            <form action="" v-on:submit.prevent="search">
              <div class="uk-margin-small">
                <div class="uk-inline">
                  <input type="text" class="uk-input" minlength="3" v-model="searchQuery" placeholder="Enter the upc or sku code" required>
                </div>
                <button class="uk-button uk-button-primary">
                  <i uk-icon="icon: search"></i>
                </button>
              </div>
              <div class="uk-margin-small">
                <div class="uk-inline">
                  <label for="type" class="uk-form-label">Search type</label>
                  <select name="type" v-model="searchType" class="uk-select" id="type">
                    <option value="all">UPC or SKU</option>
                    <option value="product_code">Product Code</option>
                    <option value="product_name">Product Name</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="uk-width-1-1">
            <div v-if="result" class="uk-width-1-1">
              <div class="search-result">
                <div class="uk-grid-small" uk-grid>
                  <div class="uk-width-1-1">
                    <h4 class="uk-text-center">Search results <small>/ Total: {{ searchResultCount }}</small></h4>
                  </div>
                  <div class="uk-width-1-1">
                    <ctable :heads="heads"
                            :data="searchResult"
                            :data-objects="dataObjects"
                            :data-icons="dataIcons"
                            :links="{show: true}"
                            :link-base="'item'"
                            :name="'items'"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import Ctable from "../components/ctable";

  export default {
    name: "Search",
    components: {Ctable},
    data() {
      return {
        result: false,
        heads: ['#ID', 'Product', 'UPC', 'SKU', 'Price', 'Created at'],
        dataObjects: ['id', 'product_name', 'upc', 'sku', 'price', 'created_at'],
        dataIcons: {'price': '<i class="fas fa-lira-sign"></i>' },
        searchQuery: '',
        searchResult: [],
        searchResultCount: 0,
        limit: 40,
        offset: 0,
        searchType: 'all'
      }
    },
    activated() {
      this.loadSearch();
    },
    mounted() {
      this.loadSearch();
    },
    watch: {
      '$route'() {
        this.loadSearch();
      }
    },
    methods: {
      async search() {
        const params = {query: this.searchQuery,
            limit: this.limit,
            offset: this.offset,
            type: this.searchType};

        this.$router.push({name: 'Search', query: params});
      },
      async loadSearch() {
        const self = this;

        self.searchQuery = (typeof self.$route.query.query !== 'undefined') ? self.$route.query.query : '';
        self.limit = (typeof self.$route.query.limit !== 'undefined') ? self.$route.query.limit : 40;
        self.offset = (typeof self.$route.query.offset !== 'undefined') ? self.$route.query.offset : 0;

        if(self.searchQuery !== '') {
          const self = this;

          self.$request().get('/search/item', {query: self.searchQuery,
            limit: self.limit,
            offset: self.offset,
            type: self.searchType})
          .then(r => {
            r = self.$request().successHandler(r).data;
            self.searchResultCount = r.total_count;

            if (r.items.length > 0) {
              console.log(r.items);
              self.result = true;
              self.searchResult = r.items;
            } else {
              self.searchResult = [];
            }
          }).catch(e => {
          });
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Search.vue